const speakersList = {
  azimova: {
    id: 1,
    name: 'Азимова Ю.Э.',
    speciality:
      'Врач-невролог, д.м.н., Университетская клиника головной боли, ФГБНУ НИИ Общей патологии и патофизиологии.',
    photo: '/img/training/speakers/azimova.png'
  },
  skorobogatyh: {
    id: 2,
    name: 'Скоробогатых К.В.',
    speciality:
      'Врач-невролог, к.м.н., руководитель Университетской клиники головной боли, Член образовательного комитета Международного общества головной боли (IHS).',
    photo: '/img/training/speakers/skorobogatyh.png'
  },
  dzgoeva: {
    id: 3,
    name: 'Дзгоева Ф. Х.',
    speciality:
      'к.м.н., диетолог, эндокринолог, врач высшей квалификационной категории',
    photo: '/img/training/speakers/dzgoeva.png'
  },
  skiba: {
    id: 4,
    name: 'Скиба Я. Б.',
    speciality:
      'к.м.н., врач-невролог, заведующий лабораторией клинической фармакологии и терапии боли Института фармакологии им. А.В. Вальдмана, ПСПбГМУ им. И.П. Павлова',
    photo: '/img/training/speakers/skiba.png'
  },
  amelin: {
    id: 5,
    name: 'Амелин А.В.',
    speciality:
      'д.м.н., профессор, руководитель Центра диагностики и лечения головной боли ФГБОУ ВО «Первый Санкт-Петербургский государственный медицинский университет им. И.П. Павлова» Минздрава России',
    photo: '/img/training/speakers/amelin.png'
  },
  filatova: {
    id: 6,
    name: 'Филатова Е. Г.',
    speciality:
      'д.м.н., профессор кафедры нервных болезней Института профессионального образования, Первый МГМУ им. И.М. Сеченова',
    photo: '/img/training/speakers/filatova.png'
  },
  tabeeva: {
    id: 7,
    name: 'Табеева Г.Р.',
    speciality:
      'д.м.н., профессор кафедры нервных болезней Института клинической медицины имени Н.В. Склифосовского, Первый МГМУ им. И.М. Сеченова',
    photo: '/img/training/speakers/tabeeva.png'
  },

}

export const webinars = [
  // {
  //   id: 1,
  //   preview_image: '/img/training/webinar1.png',
  //   type: 'Вебинар',
  //   title: 'Терапия мАТ и коморбидность',
  //   description_preview:
  //     'Обзор данных по эффективности и безопасности применения фреманезумаба',
  //   date: '2025-04-25',
  //   description: `<h3>Терапия мАТ и коморбидность</h3>
  //   <p>
  //   В видео представлен обзор данных по эффективности и безопасности применения фреманизумаба у пациентов с мигренью, имеющих сопутствующие коморбидные заболевания.
  //   Особое внимание уделено таким важным аспектам, как кардиоваскулярная и психиатрическая коморбидность. 
  //   </p>
  //   <p>
  //   Материал основан на данных клинических исследований и реальной практики и будет полезен специалистам здравоохранения, ориентированным на персонализированный подход в терапии мигрени.
  //   </p>
  //         `,
  //   video_links: [{ link: 'https://www.youtube.com/watch?v=FE3oQe7KHqo' }],
  //   speakers: [speakersList['azimova']]
  // },
  // {
  //   id: 2,
  //   preview_image: '/img/training/webinar2.png',
  //   type: 'Вебинар',
  //   title: 'Как терапия влияет на качество жизни пациента?',
  //   description_preview:
  //     'Нерешенные вопросы в профилактической терапии мигрени',
  //   date: '2025-04-25',
  //   description: `<h3>Как терапия влияет на качество жизни пациента?</h3>
          
  //         <p>
  //         Видео посвящено влиянию мигрени на качество жизни пациентов. 
  //         Представленные данные демонстрируют, насколько существенно мигрень ограничивает повседневную активность, работоспособность и эмоциональное состояние. 
  //         </p>
  //         <p>
  //         Цифры подчёркивают значительную недооцененность заболевания. 
  //         Материал будет полезен специалистам, стремящимся глубже понять бремя мигрени и значимость своевременного и эффективного лечения
  //         </p>
  //         `,
  //   video_links: [{ link: 'https://www.youtube.com/watch?v=J-MVde3B7eA' }],
  //   speakers: [speakersList['skorobogatyh']]
  // },
  // {
  //   id: 3,
  //   preview_image: '/img/training/webinar3.png',
  //   type: 'Вебинар',
  //   title:
  //     'Фреманезумаб в лечении мигрени: данные исследования реальной клинической практики в России',
  //   description_preview:
  //     'Результаты успешного применения фреманезумаба. Отдельное внимание уделено факторам',
  //   date: '2025-04-25',
  //   description: `<h3>Фреманезумаб в лечении мигрени: данные исследования реальной клинической практики в России</h3>
          
  //         <p>
  //         В видео представлены результаты применения фреманизумаба в условиях реальной клинической практики в России. 
  //         </p>
  //         <p>
  //         Отдельное внимание уделено факторам, влияющим на успешность терапии, а также практическим аспектам использования препарата у пациентов с мигренью. Материал ориентирован на врачей, ищущих доказательные и практические решения в повседневной работе.
  //         </p>
  //         `,
  //   video_links: [{ link: 'https://www.youtube.com/watch?v=My588eAYJeM' }],
  //   speakers: [speakersList['azimova']]
  // },
  // {
  //   id: 4,
  //   preview_image: '/img/training/webinar4.png',
  //   type: 'Вебинар',
  //   title: 'Как говорить с пациентом о терапии мАТ?',
  //   description_preview:
  //     'Эффективные приемы общения врача с пациентом, обсуждение терапии, ожиданий и профилактики',
  //   date: '2025-04-25',
  //   description: `<h3>Как говорить с пациентом о терапии мАТ?</h3>
          
  //         <p>
  //         Видео содержит эффективные приёмы общения врача с пациентом, включая обсуждение терапии, управление ожиданиями и вопросы профилактики. 
  //         </p>
  //         <p>
  //         Практические рекомендации помогут специалистам выстраивать доверительный диалог и повышать приверженность пациента лечению.
  //         </p>
  //         `,
  //   video_links: [{ link: 'https://www.youtube.com/watch?v=zZeSsPp9j54' }],
  //   speakers: [speakersList['azimova'], speakersList['skorobogatyh']]
  // },
  {
    id: 5,
    preview_image: '/img/training/webinar5.png',
    type: 'Вебинар',
    title: 'Эволюция таргетной терапии мигрени',
    description_preview:
      'Рассмотрим эволюцию концепции мигрени и ключевые изменения в понимании патогенеза заболевания.',
    date: '2026-02-13',
    description: `<h3>Эволюция таргетной терапии мигрени</h3>
          
          <p>
         В данном видео лектор рассматривает эволюцию концепции мигрени и ключевые изменения в понимании патогенеза заболевания. Подробно разбираются современные теории, включая роль CGRP, основные этапы его изучения и гипотезы участия в развитии мигренозной боли. 
         </p>
         <p>
         Представлены одобренные FDA лекарственные препараты для симптоматического и профилактического лечения мигрени, а также их место в клинической практике. Материал будет полезен специалистам, стремящимся связывать фундаментальные механизмы заболевания с возможностями современной терапии.
         </p>
          `,
    video_links: [{ link: 'https://youtu.be/3yiPU-uiUrc' }],
    speakers: [speakersList['tabeeva']]
  },
  {
    id: 6,
    preview_image: '/img/training/webinar6.png',
    type: 'Вебинар',
    title: 'Как не запутаться в лабиринте патогенеза мигрени',
    description_preview:
      'Рассмотрим определение мигрени и роль наследственных факторов.',
    date: '2026-02-13',
    description: `<h3>Как не запутаться в лабиринте патогенеза мигрени</h3>
          
          <p>
          В данном видео лектор последовательно рассматривает определение мигрени и роль наследственных факторов, включая данные генетики и эпигенетики. Подробно анализируются классические и современные представления о патогенезе, включая сосудистую теорию мигрени и механизмы формирования ауры. 
          </p>
          <p>
          Отдельное внимание уделено эволюции научных взглядов на природу мигренозной боли и взаимодействие ключевых биологических систем. В завершение представлены основные точки приложения препаратов, используемых в современной терапии мигрени, с позиции патофизиологии заболевания.
          </p>
          `,
    video_links: [{ link: 'https://youtu.be/poeQ6wD_qMo' }],
    speakers: [speakersList['filatova'], speakersList['skiba']]
  },
  {
    id: 7,
    preview_image: '/img/training/webinar7.png',
    type: 'Вебинар',
    title: 'Нутритивные возможности улучшения качества жизни пациента с мигренью',
    description_preview:
      'Рассмотрим роль активности жировой ткани и влияние экспозома на развитие и течение мигрени.',
    date: '2026-02-13',
    description: `<h3>Нутритивные возможности улучшения качества жизни пациента с мигренью</h3>
          
          <p>
          В видео рассматривается роль активности жировой ткани и влияние экспозома — совокупности факторов окружающей среды и образа жизни — на развитие и течение мигрени. Лектор поднимает вопросы правильного питания и обсуждает данные исследований, посвящённых влиянию различных диет на частоту и выраженность мигренозных атак. 
          </p>
          <p>
          Отдельное внимание уделено роли кофеина в профилактике мигрени и возможной связи его употребления с тяжестью приступов. Завершает материал обзор особенностей назначения витамина D и его потенциального влияния на течение заболевания.
          </p>
          `,
    video_links: [{ link: 'https://youtu.be/_zJHrnY2e-U' }],
    speakers: [speakersList['dzgoeva']]
  },
  {
    id: 8,
    preview_image: '/img/training/webinar8.png',
    type: 'Вебинар',
    title: 'От РКИ к реальной клинической практике',
    description_preview:
      'Рассмотрим традиционные средства профилактики мигрени и ключевые аспекты нейробиологии заболевания.',
    date: '2026-02-13',
    description: `<h3>От РКИ к реальной клинической практике</h3>
          
          <p>
          В видео рассматриваются традиционные средства профилактики мигрени и ключевые аспекты нейробиологии заболевания. Лектор подробно описывает эффекты болевого медиатора CGRP при мигрени и объясняет, почему он является важной терапевтической мишенью. Представлен обзор моноклональных антител, применяемых в неврологии, с акцентом на данные РКИ по эффективности фреманизумаба. 
          </p>
          <p>
          Также обсуждаются результаты мета-анализа CGRP-антител при рефрактерной мигрени и данные реальной клинической практики, подтверждающие их пользу у пациентов, не отвечающих на стандартные методы профилактики. Материал будет полезен специалистам, ориентированным на доказательный и персонализированный подход в лечении мигрени.
          </p>
          `,
    video_links: [{ link: 'https://youtu.be/iMQVbh4PGcA' }],
    speakers: [speakersList['amelin']]
  },
]
